import { EServiceId, EUnavailableReason } from '../../../types/reducers/publishTerms';
import { EServiceTypes } from '../publicationPackages/types';

export interface IPromotionState {
  toggle: IPromotionToggle;
  restriction: IRestriction;
  auctionBet: IAuctionBet;
  duration: IDurationState;
  services: IPromotionService[];
  banner?: {
    promotionTypeChangeReason: string | null;
  };
  competitors: ICompetitorService[];
  isChangedByUser: boolean;
  promoBannerInfo?: IPromoBannerInfo;
}

export interface IRestriction {
  isAllowed: boolean;
  restrictionType?: ERestrictionType;
}
export enum ERestrictionType {
  /** Исчерпан лимит объявлений для субагента **/
  'SubAgentLimitExceeded' = 'subAgentLimitExceeded',
  /** Когда у субагента есть запрет на топ и премиум **/
  'DeniedByStrategy' = 'deniedByStrategy',
  /** У пользователя запрет на продвижение **/
  'DeniedBySanctions' = 'deniedBySanctions',
}

export interface IPromotionToggle {
  checked: boolean;
  disabled: boolean;
  changedByUser?: boolean;
}

export interface IAuctionBet {
  available: boolean;
  restrictionType: ERestrictionType | undefined;
  value: number;
  step: number;
  minBet: number;
  maxBet: number;
  token: string;
  // @deprecated
  previousBets: number[];
  // @deprecated
  nextBets: number[];
}

export interface IDurationState {
  defaultDuration: number;
  durations: IDuration[];
}

export interface IDuration {
  durationInDays: number;
  discountPercent: number;
  selected: boolean;
  isPromoDiscount: boolean;
}

export interface IPromotionService {
  type: EServiceId;
  price: number;
  selected: boolean;
  token: string;
  disabled: boolean;
  isRecommended: boolean;
  unavailableReasonType: EUnavailableReason | null;
  tariffIdentificator: ITariffIdentificator;
  diffPriceId: number;
  diffPriceIterationId: string;
  diffPriceGranuleGuid: string;
}

export interface ITariffIdentificator {
  tariffId: number;
  tariffGridType: string;
  days: number;
  periodType: string;
  serviceTypes: EServiceTypes[];
  packageId: number;
}

export const enum ECompetitorsLevel {
  high = 'high',
  medium = 'medium',
  low = 'low',
}

export const enum ECompetitorsPromotionType {
  noPromotion = 'noPromotion',
  standard = 'standard',
  premium = 'premium',
  top = 'top',
  topWithBet = 'topWithBet',
}

export interface ICompetitorService {
  promotionType: ECompetitorsPromotionType;
  amount: number;
  competitionLevel: ECompetitorsLevel;
}

export interface IPromoBannerInfo {
  title: string;
  endDate: string;
}
